import type { HostColorScheme } from "@/features/app/appSlice";

import { ColorThemes } from "@/features/app/constants";

export const getThemeMediaQueryList = () => {
  if (typeof window.matchMedia !== "function") {
    return null;
  }

  return window.matchMedia("(prefers-color-scheme: dark)");
};

/**
 * Checks whether a theme value is valid for the host preference API.
 *
 * Returns `true` when the value is valid and `false` otherwise.
 */
export const isValidHostColorScheme = (value: unknown): boolean => {
  return value === "dark" || value === "light" || value === null;
};

export const resolveSystemTheme = (
  hostColorSchemePreference: HostColorScheme | null,
) =>
  hostColorSchemePreference === "dark"
    ? ColorThemes.dark
    : hostColorSchemePreference === "light"
      ? ColorThemes.light
      : getThemeMediaQueryList()?.matches
        ? ColorThemes.dark
        : ColorThemes.light;
